import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import MuiDialog from 'components/MuiDialog';
import {
  SurveyDialogProps,
  TCoreNursingSkillVideoDefaultValues as TCoreNursingSkillVideoDeExemplefaultValues,
} from 'routes/Main/Survey/type';
import useNotification from 'hooks/useNotification';
import useUser from 'store/user/useUser';

import Contents1 from './Contents1';
import Contents2 from './Contents2';
import Contents3 from './Contents3';
import Contents4 from './Contents4';
import Contents5 from './Contents5';
import Contents6 from './Contents6';
import Contents7 from './Contents7';
import { postLogin } from 'apis/account';

const CoreNursingSkillVideoExempleTwo = (
  props: SurveyDialogProps<TCoreNursingSkillVideoDeExemplefaultValues>
) => {
  const {
    student_uuid: userId,
    student_id,
    student_name,
    student_gender,
    student_grade,
    college_name,
    student_birth,
    student_no,
  } = useUser();
  const { onResultCode } = useNotification();

  const { handleSubmit, getValues, register, reset } = useForm({
    defaultValues: {
      student_id,
      student_name,
      student_gender,
      student_grade,
      college_name,
      student_birth,
      student_no,
    } as any,
  });
  const [isConfirmPassword, setIsConfirmPassword] = useState(false);
  const onConfirmPassword = () => {
    const password = getValues('password');
    postLogin({ user_email: student_id!, user_password: password }).then(
      ({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);
        setIsConfirmPassword(true);
      }
    );
  };
  const { title, isOpen, onClose } = props;

  return (
    <MuiDialog.SurveyFormTwo title={title} isOpen={isOpen} onClose={onClose}>
      <Contents1
        studentGrade={student_grade!}
        studentGender={student_gender!}
        register={register}
        isConfirmPassword={isConfirmPassword}
        onConfirmPassword={onConfirmPassword}
      />
      <Contents2
        studentGrade={student_grade!}
        studentGender={student_gender!}
        register={register}
        isConfirmPassword={isConfirmPassword}
        onConfirmPassword={onConfirmPassword}
      />
      <Contents3
        studentGrade={student_grade!}
        studentGender={student_gender!}
        register={register}
        isConfirmPassword={isConfirmPassword}
        onConfirmPassword={onConfirmPassword}
      />
      <Contents4
        studentGrade={student_grade!}
        studentGender={student_gender!}
        register={register}
        isConfirmPassword={isConfirmPassword}
        onConfirmPassword={onConfirmPassword}
      />
      <Contents5
        studentGrade={student_grade!}
        studentGender={student_gender!}
        register={register}
        isConfirmPassword={isConfirmPassword}
        onConfirmPassword={onConfirmPassword}
      />
      <Contents6
        studentGrade={student_grade!}
        studentGender={student_gender!}
        register={register}
        isConfirmPassword={isConfirmPassword}
        onConfirmPassword={onConfirmPassword}
      />
      <Contents7
        studentGrade={student_grade!}
        studentGender={student_gender!}
        register={register}
        isConfirmPassword={isConfirmPassword}
        onConfirmPassword={onConfirmPassword}
      />
    </MuiDialog.SurveyFormTwo>
  );
};

export default CoreNursingSkillVideoExempleTwo;
